console.log("- Smart-cart-rebuy works!");

document.addEventListener("rebuy.loaded", (event) => {
  if (window.Rebuy && window.Rebuy.SmartCart) {
    console.info("SmartCart is ready!");
  } else {
    console.error("SmartCart is not ready.");
  }
});

document.addEventListener("rebuy:smartcart.show", (event) => {
  const subtotalSlot = document.getElementById("subtotalInCol");
  const becomeAnInsiderWrapper = document.getElementsByClassName(
    "become-an-insider__container"
  );

  if (isSubscriptionInCart() && becomeAnInsiderWrapper.length > 0) {
    becomeAnInsiderWrapper[0].style.display = "none";
  } else if (!isSubscriptionInCart() && becomeAnInsiderWrapper.length > 0) {
    becomeAnInsiderWrapper[0].style.display = "block";
  }

  if (subtotalSlot) {
    console.log("!subtotalSlot in show cart::", subtotalSlot);
    if (window.Rebuy && window.Rebuy.SmartCart) {
      const originalTotal = window.Rebuy.SmartCart.getOriginalCartTotal();
      const discountTotal = window.Rebuy.SmartCart.getCalculatedCartDiscount();
      const subTotal = originalTotal - discountTotal;
      const cashbackTotal = subTotal * 0.2;
      const formattedTotal = `$${(cashbackTotal / 100).toFixed(2)}`;

      subtotalSlot.textContent = formattedTotal;
    } else {
      console.error("SmartCart is not ready.");
    }
  } else {
    console.warn("SubTotal Slot not found.");
  }
});

document.addEventListener("rebuy:cart.change", (event) => {
  const subtotalSlot = document.getElementById("subtotalInCol");
  const becomeAnInsiderWrapper = document.getElementsByClassName(
    "become-an-insider__container"
  );

  if (isSubscriptionInCart() && becomeAnInsiderWrapper.length > 0) {
    becomeAnInsiderWrapper[0].style.display = "none";
  } else if (!isSubscriptionInCart() && becomeAnInsiderWrapper.length > 0) {
    becomeAnInsiderWrapper[0].style.display = "block";
  }

  if (subtotalSlot) {
    console.log("!subtotalSlot in change cart::", subtotalSlot);
    if (window.Rebuy && window.Rebuy.SmartCart) {
      const originalTotal = window.Rebuy.SmartCart.getOriginalCartTotal();
      const discountTotal = window.Rebuy.SmartCart.getCalculatedCartDiscount();
      const subTotal = originalTotal - discountTotal;
      const cashbackTotal = subTotal * 0.2;
      const formattedTotal = `$${(cashbackTotal / 100).toFixed(2)}`;

      subtotalSlot.textContent = formattedTotal;
    } else {
      console.error("SmartCart is not ready.");
    }
  } else {
    console.warn("SubTotal Slot not found.");
  }
});

window.becomeAnInsiderCTA = function () {
  // HH userPlanID for memership
  const userPlanID = 50164709884203;
  if (userPlanID) {
    window.inveterateRebuy.addToCart(userPlanID);
  }
};

const isSubscriptionInCart = () => {
  const cartItems = window.Rebuy.Cart.items();
  return cartItems.some((item) => item.id == 50164709884203);
};
